module.exports = __webpack_public_path__ + "dingbeauty-build/img/service-default-Image.0871269f.svg";